import { Controller, FieldValues, RegisterOptions, useFormContext } from "@graphcommerce/ecommerce-ui";
import { TextareaHTMLAttributes } from "react";

type SimpleTextAreaProps = {
  name: string;
  label?: string,
  rules?: Omit<RegisterOptions<FieldValues, string>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled">
} & TextareaHTMLAttributes<HTMLTextAreaElement>
export default function SimpleTextArea({ name, label, required, rules, rows }: SimpleTextAreaProps) {
  const { control, formState: { errors } } = useFormContext()
  return (
    <div className="relative pb-1">
      <Controller
        name={name}
        control={control}
        rules={{
          ...rules,
          ...(required ? { required: `واردکردن موارد ستاره‌دار الزامی است.` } : null)
        }}
        render={({ field }) => (
          <>
            {label && <label className="block text-sm mb-2">{label}<span className="text-error-500">*</span></label>}
            <textarea rows={rows} {...field} className={`border text-sm text-default-800 outline-0 border-solid border-light-170 focus:bg-light-100 p-2 block w-full ${!rows && 'min-h-[150px]'}`}></textarea>
          </>
        )}
      />
      {errors[name] ? <span className="text-sm text-red-500 absolute right-0 top-[100%]">{errors[name]?.message as string}</span> : null}
    </div>
  )
}